module.exports = __webpack_public_path__ + "img/keila.52df9964.svg";